function initializeVariantPickerV2(picker) {
  const url = new URL(window.location.href);
  if (window.Shopify.designMode || url.searchParams.has('variant')) return;

  const defaultVariant = JSON.parse(
    picker.querySelector('script[data-default-variant]')?.textContent || '{}'
  );
  if (!defaultVariant?.id || !defaultVariant?.options) return;

  const carousel = document.querySelector('product-gallery')?.carousel;
  const form = document.forms[picker.getAttribute('form-id')];
  const variantScript = picker.querySelector('script[data-variant]');

  const { scrollX, scrollY } = window;
  const scrollBehavior = document.documentElement.style.scrollBehavior;
  document.documentElement.style.scrollBehavior = 'auto';
  carousel?.setAttribute('data-skip-next-select', 'true');

  variantScript.textContent = JSON.stringify(defaultVariant);

  const inputMap = defaultVariant.options.reduce((map, _, index) => {
    const position = index + 1;
    map[position] = Array.from(
      picker.querySelectorAll(`input[data-option-position="${position}"]`)
    );
    return map;
  }, {});

  defaultVariant.options.forEach((optionValue, index) => {
    const position = index + 1;
    const input = inputMap[position]?.find((candidate) => {
      const label = candidate.nextElementSibling;
      const labelText = label?.querySelector('.variant-picker-v2__block-label')?.textContent?.trim();
      return labelText === optionValue;
    });

    if (input && !input.checked) {
      input.checked = true;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
  });

  if (form) {
    const idInput = form.querySelector('input[name="id"]');
    if (idInput) {
      idInput.value = defaultVariant.id;
      idInput.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  window.scrollTo(scrollX, scrollY);
  document.documentElement.style.scrollBehavior = scrollBehavior;
}

function initAllVariantPickersV2() {
  document.querySelectorAll('variant-picker-v2').forEach(initializeVariantPickerV2);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initAllVariantPickersV2);
} else {
  initAllVariantPickersV2();
}
